export default {
    namespaced: true,

    state: {
        mailingInfo: {}
    },

    mutations: {
        setMailingInfo(state, data) {            
            state.mailingInfo = data;
            localStorage.setItem('mailingInfo', JSON.stringify(state.mailingInfo));
        },
    }
};